import { render } from "./loadingModal.vue?vue&type=template&id=5d177024&scoped=true"
import script from "./loadingModal.vue?vue&type=script&lang=js"
export * from "./loadingModal.vue?vue&type=script&lang=js"

import "./loadingModal.vue?vue&type=style&index=0&id=5d177024&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d177024"]])

export default __exports__